document.addEventListener('DOMContentLoaded', function () {

  const tabs = document.querySelectorAll('.tab-btn[data-tab]');

  tabs.forEach(btn => {

    btn.addEventListener('click', function () {

      document
        .querySelectorAll('.tab-btn')
        .forEach(b => b.classList.remove('active'));

      document
        .querySelectorAll('.showcase-panel')
        .forEach(panel => panel.classList.remove('active'));

      this.classList.add('active');

      const panel = document.getElementById(
        'panel-' + this.dataset.tab
      );

      if(panel){
        panel.classList.add('active');
      }

    });

  });

});


(function(){
  var list=document.getElementById('vxFaq');
  if(!list)return;
  list.addEventListener('click',function(e){
    var btn=e.target.closest('.vx-faq-q');
    if(!btn)return;
    var item=btn.parentElement;
    var body=item.querySelector('.vx-faq-body');
    var isOpen=item.classList.contains('open');
    list.querySelectorAll('.vx-faq-item.open').forEach(function(i){
      i.classList.remove('open');
      i.querySelector('.vx-faq-body').style.maxHeight=null;
    });
    if(!isOpen){
      item.classList.add('open');
      body.style.maxHeight=body.scrollHeight+'px';
    }
  });
})();

function initVXVideos() {

  document.querySelectorAll('.vx-video-wrapper').forEach(wrapper => {


    if (wrapper.dataset.init === "1") return;
    wrapper.dataset.init = "1";

    wrapper.addEventListener('click', function () {

      const videoId = this.dataset.videoId;

      const iframe = document.createElement('iframe');

      iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&playsinline=1&rel=0`;
      iframe.allow = "autoplay; encrypted-media; picture-in-picture";
      iframe.allowFullscreen = true;

      iframe.style.width = "100%";
      iframe.style.aspectRatio = "16/9";
      iframe.style.border = "0";
      iframe.style.display = "block";

      this.innerHTML = "";
      this.appendChild(iframe);

    });

  });

}


document.addEventListener("DOMContentLoaded", initVXVideos);
window.addEventListener("load", initVXVideos);

